import {
    apiRequest,
    riwayatPangkatList,
    riwayatpangkatInactive
} from "../../../../../services/adapters/kepegawaian/riwayatPangkatService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", riwayatPangkatList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", riwayatpangkatInactive, {
            body: query
        }, true)
    }
}

export default DataTableRepository